import { render, staticRenderFns } from "./restartCases.vue?vue&type=template&id=150d0d80&scoped=true"
import script from "./restartCases.vue?vue&type=script&lang=js"
export * from "./restartCases.vue?vue&type=script&lang=js"
import style0 from "./restartCases.vue?vue&type=style&index=0&id=150d0d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d0d80",
  null
  
)

export default component.exports